import { render, staticRenderFns } from "./RevisionTechnicalForm.vue?vue&type=template&id=1127cb4a&scoped=true"
import script from "./RevisionTechnicalForm.vue?vue&type=script&lang=js"
export * from "./RevisionTechnicalForm.vue?vue&type=script&lang=js"
import style0 from "./RevisionTechnicalForm.vue?vue&type=style&index=0&id=1127cb4a&prod&lang=scss"
import style1 from "./RevisionTechnicalForm.vue?vue&type=style&index=1&id=1127cb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127cb4a",
  null
  
)

export default component.exports